import { LOGIN_INFO } from '../../../comm/constant';
import { userRoleList } from '../../../utils/userRole';
import { GET_USERROLE, UPDATE_USERROLE } from '../../constant';

const userRole = (state = null, action) => {
  const { type, data } = action;
  switch (type) {
    case GET_USERROLE:
      return state;
    case UPDATE_USERROLE:
      try {
        const loginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));
        userRoleList.setGlobalUserRoleTypeId(data, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);
      } catch {
        userRoleList.setGlobalUserRoleTypeId(-1);
      }
      return data;
    default:
      return state;
  }
};

export { userRole };
